@if (!showSettings()) {
	<div class="container">
		<div class="content">
			<div class="location-list-wrapper nice-scroll visible-scroll colored-scroll-track">
				<au-locations-tree-selector (locationsChanged)="locations.set($event)" />
			</div>
		</div>
		<div class="footer">
			<div class="left">
				<div class="description">
					<span class="white-box"> ESC </span>
					<p class="text">{{ 'close' | translate }}</p>
				</div>
			</div>
			<div class="right">
				<button
					mat-ripple
					class="copy-button"
					(click)="showSettings.set(true)"
					[disabled]="!locations().length"
				>
					<span>{{ 'next' | translate }}</span>
				</button>
			</div>
		</div>
	</div>
}

@if (showSettings() && selection.length > 0) {
	<div class="settings-container">
		<div class="content">
			<div class="title">
				<h3>{{ 'select_fields_to_copy' | translate }}</h3>
				<mat-icon class="cursor-pointer" (click)="closeWithoutAction()">close</mat-icon>
			</div>
			<div class="title-desc">{{ 'select_fields_to_copy_description' | translate }}</div>
			@for (field of fields; track field) {
				@if (shouldDisplayField(field.key)) {
					<div class="field">
						<p>
							{{ field.label }}
							<mat-slide-toggle
								[(ngModel)]="settingOptions[field.key]"
								hideIcon="true"
								[checked]="true"
								class="mat-slide-toggle"
							></mat-slide-toggle>
						</p>
						<div [ngClass]="{ disabled: !settingOptions[field.key] }">
							@if (isNotInDifference(field.key)) {
								<span>
									@switch (field.key) {
										@case ('priority') {
											<au-priority-level
												[level]="selection[0].priority"
											></au-priority-level>
										}
										@case ('assignee') {
											<au-avatar-with-name
												[data]="selection[0].assignee"
											></au-avatar-with-name>
										}
										@case ('category') {
											<au-body-text [text]="lowerCaseCategory()"></au-body-text>
										}
										@case ('approver') {
											<au-avatar-with-name
												[data]="selection[0].approver"
											></au-avatar-with-name>
										}
										@case ('deadline') {
											<au-body-text [text]="formatDate()"></au-body-text>
										}
										@case ('routineData') {
											<au-body-text [text]="stringifyRoutineData()"></au-body-text>
										}
										@case ('labels') {
											<au-cmms-label-column
												[labels]="selection[0].labels"
											></au-cmms-label-column>
										}
										@case ('checklists') {
											<au-body-text [text]="checklistParse()"></au-body-text>
										}
									}
								</span>
							} @else {
								<h5>{{ 'mixed' | translate }}</h5>
							}
						</div>
					</div>
				}
			}
		</div>
		<div class="footer">
			<div class="left">
				<div class="description">
					<span class="white-box"> ESC </span>
					<p class="text">{{ 'close' | translate }}</p>
				</div>
			</div>
			<div class="right">
				<button mat-ripple class="copy-button" (click)="copyButtonClicked()">
					<span>{{ 'create_copies' | translate }}</span>
				</button>
			</div>
		</div>
	</div>
}
